/* LUXURIA – Header: Mega-Menü (Desktop) und Mobile-Navigation mit Ebenen. Ohne Bibliothek. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 990px)');

  // Mega-Menü mit Vorschau: aktiver Bereich/Marke steuert den Detailbereich rechts
  function initPanes(panel) {
    var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-lux-pane]'));
    if (!rows.length) return;
    var paneTimer = null;

    function activate(row) {
      rows.forEach(function (r) {
        var active = r === row;
        r.classList.toggle('is-active', active);
        var pane = document.getElementById(r.getAttribute('data-lux-pane'));
        if (pane) pane.hidden = !active;
      });
    }

    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        clearTimeout(paneTimer);
        // kurze Verzögerung: diagonales Hinüberfahren zur Detailspalte wechselt nicht versehentlich
        paneTimer = setTimeout(function () { activate(row); }, 70);
      });
      row.addEventListener('mouseleave', function () { clearTimeout(paneTimer); });
      row.addEventListener('focus', function () { activate(row); });
      if (row.tagName === 'BUTTON') row.addEventListener('click', function () { activate(row); });
    });

    panel.__luxResetPanes = function () { activate(rows[0]); };
  }

  function initMega(header) {
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-lux-mega-trigger]'));
    var backdrop = header.querySelector('[data-lux-mega-backdrop]');
    var openTrigger = null;
    var hoverTimer = null;

    function panelOf(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function close() {
      if (!openTrigger) return;
      var panel = panelOf(openTrigger);
      openTrigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      if (backdrop) backdrop.hidden = true;
      header.classList.remove('is-mega-open');
      openTrigger = null;
    }

    // Panel nie höher als der sichtbare Bereich unter dem Header – bei niedrigen Bildschirmen scrollt das Panel selbst
    function fitHeight(panel) {
      if (!panel || panel.hidden) return;
      var top = panel.getBoundingClientRect().top;
      panel.style.setProperty('--lux-mega-max', Math.max(240, window.innerHeight - top - 16) + 'px');
    }

    function open(trigger) {
      if (openTrigger === trigger) return;
      close();
      var panel = panelOf(trigger);
      if (!panel) return;
      if (panel.__luxResetPanes) panel.__luxResetPanes();
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      fitHeight(panel);
      panel.scrollTop = 0;
      if (backdrop) backdrop.hidden = false;
      header.classList.add('is-mega-open');
      openTrigger = trigger;
    }

    triggers.forEach(function (trigger) {
      var item = trigger.closest('.lux-nav__item');
      var panel = panelOf(trigger);
      if (panel) initPanes(panel);
      trigger.addEventListener('click', function () {
        if (openTrigger === trigger) close();
        else open(trigger);
      });
      item.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { open(trigger); }, openTrigger ? 0 : 120);
      });
      item.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(close, 220);
      });
    });

    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openTrigger) {
        var t = openTrigger;
        close();
        t.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (openTrigger && !e.target.closest('.lux-nav__item')) close();
    });

    header.addEventListener('focusout', function (e) {
      if (openTrigger && e.relatedTarget && !openTrigger.closest('.lux-nav__item').contains(e.relatedTarget)) close();
    });

    // Klick auf einen Link im Panel (z. B. Fahrzeug-Check-Deep-Link auf derselben Seite) schließt das Menü
    triggers.forEach(function (trigger) {
      var panel = panelOf(trigger);
      if (!panel) return;
      panel.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) close();
      });
    });

    if (backdrop) backdrop.addEventListener('click', close);
    window.addEventListener('scroll', function () { if (openTrigger && window.scrollY > 200) close(); }, { passive: true });
    window.addEventListener('resize', function () { if (openTrigger) fitHeight(panelOf(openTrigger)); });
  }

  function initMobile() {
    var nav = document.querySelector('[data-lux-mnav]');
    var openBtn = document.querySelector('[data-lux-mnav-open]');
    if (!nav || !openBtn || nav.__luxMnav) return;
    nav.__luxMnav = true;
    var panel = nav.querySelector('.lux-mnav__panel');
    var root = nav.querySelector('#LuxMnavRoot');
    var current = root;
    var stack = [];
    var lastFocus = null;

    function isVisible(el) {
      var level = el.closest('[data-lux-level]');
      if (level && level !== current) return false;
      return el.offsetParent !== null;
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('a[href], button, input'))
        .filter(isVisible);
    }

    function show(level, direction) {
      var prev = current;
      if (direction === 'forward') {
        prev.classList.add('is-behind');
      } else {
        level.classList.remove('is-behind');
      }
      prev.classList.remove('is-active');
      level.classList.add('is-active');
      level.scrollTop = 0;
      current = level;
    }

    function go(id, trigger) {
      var level = document.getElementById(id);
      if (!level || level === current) return;
      stack.push({ level: current, trigger: trigger });
      show(level, 'forward');
      var back = level.querySelector('[data-lux-mnav-back]');
      if (back) back.focus({ preventScroll: true });
    }

    function back() {
      var entry = stack.pop();
      if (!entry) return;
      show(entry.level, 'back');
      if (entry.trigger) entry.trigger.focus({ preventScroll: true });
    }

    function reset() {
      stack = [];
      nav.querySelectorAll('[data-lux-level]').forEach(function (level) {
        level.classList.remove('is-active', 'is-behind');
      });
      root.classList.add('is-active');
      current = root;
    }

    function open() {
      lastFocus = document.activeElement;
      reset();
      nav.hidden = false;
      requestAnimationFrame(function () { nav.classList.add('is-open'); });
      document.documentElement.classList.add('lux-mnav-open');
      openBtn.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('.lux-mnav__close');
      if (first) first.focus();
    }

    function close() {
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('lux-mnav-open');
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { nav.hidden = true; reset(); }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-lux-mnav-close]')) { close(); return; }
      var goBtn = e.target.closest('[data-lux-mnav-go]');
      if (goBtn) { go(goBtn.getAttribute('data-lux-mnav-go'), goBtn); return; }
      if (e.target.closest('[data-lux-mnav-back]')) { back(); return; }
      var link = e.target.closest('a[href]');
      // Sprunglinks auf derselben Seite (z. B. #fahrzeug-check): Menü schließen
      if (link && link.getAttribute('href').indexOf('#') !== -1) close();
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (stack.length) back();
        else close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    desktop.addEventListener && desktop.addEventListener('change', function (m) { if (m.matches && !nav.hidden) close(); });
  }

  function init() {
    document.querySelectorAll('[data-lux-header]').forEach(function (header) {
      if (header.__luxHeader) return;
      header.__luxHeader = true;
      initMega(header);
    });
    initMobile();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
